import React from "react";

export default function ClientShell(): React.ReactElement {
  return (
    <main style={{ fontFamily: "system-ui", padding: "2rem" }}>
      <h1>Client Portal</h1>
      <p>Read-only view for end customers (P5+).</p>
    </main>
  );
}
